import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Fab } from '@material-ui/core';

export default class ACButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const spanMargin = this.props.spanMargin || '0 10px';

        let values = [
            <span
                key={this.props.text + uuidv4()}
                style={{
                    margin: spanMargin,
                }}
            >
                {this.props.text}
            </span>,
        ];

        if (this.props.Icon) {
            const Icon = this.props.Icon;
            const iconComponent = <Icon key="icon" width="1.5em" />;

            if (!this.props.iconLast) {
                values.unshift(iconComponent);
            } else {
                values.push(iconComponent);
            }
        }

        if (this.props.icon) {
            const icon = this.props.icon;

            if (!this.props.iconLast) {
                values.unshift(icon);
            } else {
                values.push(icon);
            }
        }

        const backgroundColor = this.props.backgroundColor || 'white';
        const color = this.props.color || '#52A8EF';
        const fontFamily = this.props.fontFamily || 'gilroy-regular';
        const fontSize = this.props.fontSize || '12px';
        const padding = this.props.padding || '2px 16px';
        const border = this.props.border || '';
        const margin = this.props.margin || '';
        const zIndex = this.props.zIndex || '1';
        const position = this.props.position || '';
        const bottom = this.props.bottom || '';

        return (
            <Fab
                key={'fab' + uuidv4()}
                variant="extended"
                size="small"
                style={{
                    backgroundColor: backgroundColor,
                    color: color,
                    fontSize: fontSize,
                    boxShadow: '0 0',
                    textTransform: 'none',
                    padding: padding,
                    border: border,
                    margin: margin,
                    fontFamily: fontFamily,
                    zIndex: zIndex,
                    position: position,
                    bottom: bottom
                }}
                className={this.props.className}
                onClick={this.props.onClickFunc}
                disabled={this.props.disabled}
            >
                {values}
            </Fab>
        );
    }
}
